<span class="relative inline-flex items-center">
  <p-button
    icon="pi pi-box"
    severity="secondary"
    [text]="true"
    [pTooltip]="count > 0 ? count + ' consumables' : 'Consumables'"
    tooltipPosition="top"
    (onClick)="open()"
  />
  @if (count > 0) {
    <span
      class="absolute -top-1 -right-1 bg-primary text-white text-[10px] rounded-full px-1 leading-none pointer-events-none"
      >{{ count }}</span
    >
  }
</span>

<p-dialog
  header="Consumables"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '32rem' }"
  appendTo="body"
>
  <div class="flex flex-col gap-3">
    <p-iconfield>
      <p-inputicon styleClass="pi pi-search" />
      <input
        pInputText
        [(ngModel)]="searchQuery"
        placeholder="Search consumables"
        class="w-full"
      />
    </p-iconfield>
    <div
      class="max-h-48 overflow-y-auto rounded border border-surface-switch-200"
    >
      @for (consumable of searchResults; track consumable.id) {
        <div
          class="flex items-center justify-between gap-3 border-b border-surface-switch-200 px-3 py-2 last:border-b-0"
        >
          <div class="min-w-0">
            <div class="font-medium">{{ consumable.name }}</div>
            <div class="text-sm">
              {{ consumable.cost | currency: currencyCode }} /
              {{ unitLabel(consumable.unit) }}
            </div>
            @if (consumable.description) {
              <div class="mt-1 text-xs italic text-muted-color line-clamp-2">
                {{ consumable.description }}
              </div>
            }
          </div>
          <p-button
            label="Add"
            size="small"
            severity="secondary"
            (onClick)="add(consumable)"
          />
        </div>
      } @empty {
        <div class="px-3 py-4 text-sm text-muted-color">
          No matching consumables.
        </div>
      }
    </div>

    @for (row of draft; track row.consumable_id) {
      <div class="flex items-center gap-3">
        <div class="min-w-0 flex-1">
          <div class="truncate font-medium">{{ row.name }}</div>
          @if (row.description) {
            <div class="truncate text-xs italic text-muted-color">
              {{ row.description }}
            </div>
          }
        </div>
        <div class="flex items-center gap-2">
          <p-inputNumber
            [(ngModel)]="row.quantity"
            [min]="0.000001"
            [minFractionDigits]="0"
            [maxFractionDigits]="6"
            [showButtons]="true"
            inputStyleClass="w-24"
          />
          @if (row.unit) {
            <span class="shrink-0 text-sm text-muted-color">{{
              unitLabel(row.unit)
            }}</span>
          }
        </div>
        <p-button
          icon="pi pi-times"
          severity="secondary"
          [text]="true"
          [rounded]="true"
          (onClick)="remove(row.consumable_id)"
        />
      </div>
    } @empty {
      <div class="text-sm text-muted-color">No consumables on this item.</div>
    }
  </div>
  <ng-template pTemplate="footer">
    <p-button label="Cancel" severity="secondary" (onClick)="visible = false" />
    <p-button label="Save" icon="pi pi-check" (onClick)="save()" />
  </ng-template>
</p-dialog>
